import script from "./RecentActivityList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentActivityList.vue?vue&type=script&setup=true&lang=ts"

import "./RecentActivityList.vue?vue&type=style&index=0&id=f29bb16a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f29bb16a"]])

export default __exports__